var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "card", attrs: { "data-schools-rank": "" } },
    [
      _c(
        "h5",
        {
          staticClass:
            "card-header d-flex justify-content-between align-items-center school-rank-title",
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.showHeader
                  ? _vm.ui.formatString(_vm.T.schoolRankOfTheMonthHeader, {
                      count: _vm.rank ? _vm.rank.length : 0,
                    })
                  : _vm.ui.formatString(_vm.T.schoolRankRangeHeader, {
                      lowCount: (_vm.page - 1) * _vm.length + 1,
                      highCount: _vm.page * _vm.length,
                    })
              ) +
              " "
          ),
          _c(
            "a",
            { attrs: { href: _vm.SchoolRankingFeatureGuideURL } },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["fas", "question-circle"] },
              }),
              _vm._v(" " + _vm._s(_vm.T.wordsRankingMeasurement) + " "),
            ],
            1
          ),
        ]
      ),
      !_vm.showHeader
        ? _c(
            "div",
            { staticClass: "card-body form-row" },
            [
              _c("omegaup-common-typeahead", {
                staticClass: "col col-md-4 pl-0 pr-2",
                attrs: {
                  "existing-options": _vm.searchResultSchools,
                  value: _vm.searchedSchool,
                  "max-results": 10,
                },
                on: {
                  "update:value": function ($event) {
                    _vm.searchedSchool = $event
                  },
                  "update-existing-options": (query) =>
                    _vm.$emit("update-search-result-schools", query),
                },
              }),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary form-control col-4 col-md-2",
                  attrs: { type: "button" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(" " + _vm._s(_vm.T.searchSchool) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("table", { staticClass: "table mb-0" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
              _vm._v("#"),
            ]),
            _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
              _vm._v(_vm._s(_vm.T.profileSchool)),
            ]),
            _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
              _vm._v(_vm._s(_vm.T.wordsScore)),
            ]),
          ]),
        ]),
        _c(
          "tbody",
          _vm._l(_vm.rank, function (school, index) {
            return _c("tr", { key: index }, [
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "row" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showHeader ? index + 1 : school.ranking || ""
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "td",
                { staticClass: "text-truncate text-center" },
                [
                  _c("omegaup-countryflag", {
                    attrs: { country: school.country_id },
                  }),
                  _c(
                    "a",
                    {
                      attrs: { href: `/schools/profile/${school.school_id}/` },
                    },
                    [_vm._v(_vm._s(school.name))]
                  ),
                ],
                1
              ),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(" " + _vm._s(school.score.toFixed(2)) + " "),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm.showHeader
        ? _c("div", { staticClass: "card-footer" }, [
            _c("a", { attrs: { href: "/rank/schools/" } }, [
              _vm._v(_vm._s(_vm.T.rankSeeGeneralRanking)),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "card-footer" },
            [
              _c("omegaup-common-paginator", {
                attrs: { "pager-items": _vm.pagerItems },
              }),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }